import React from 'react';
import PropTypes from 'prop-types';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';

class TopicTitle extends React.PureComponent {
    static propTypes = {
        id: PropTypes.string,
        moduleIndex: PropTypes.number,
        title: PropTypes.string,
        titleAd: PropTypes.object,
    };

    render() {
        const { id, moduleIndex, title, titleAd } = this.props;

        return (
            <div className={styles.title_box} data-title={title}>
                <span className={styles.bar} />
                <span className={styles.title}>{title}</span>
                <Ad content={titleAd} />
            </div>
        );
    }
}

export default errorBoundary(TopicTitle);
